import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

const PHONE_HREF = 'tel:+18059229684';
const MAPS_HREF = 'https://www.google.com/maps/dir/?api=1&destination=926+W+Main+St,+Santa+Maria,+CA+93458';
const MAPS_EMBED = 'https://maps.google.com/maps?q=926+W+Main+St,+Santa+Maria,+CA+93458&t=&z=15&ie=UTF8&iwloc=&output=embed';

function PhoneIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.66h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-1.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  );
}
function MapPinIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  );
}

export default function Location() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { t } = useLang();

  const hours = [
    { day: t.locMonThu, time: '8:00 AM \u2013 5:00 PM', closed: false },
    { day: t.locFri, time: '8:00 AM \u2013 3:00 PM', closed: false },
    { day: t.locSat, time: t.locClosed, closed: true },
    { day: t.locSun, time: t.locClosed, closed: true },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="sm-section" style={{ background: '#fff' }} data-testid="location-section" ref={ref}>
      <div className="sm-container">
        <div className="reveal-item" style={visible ? { opacity: 1, transform: 'translateY(0)' } : {}}>
          <div className="section-label">{t.locLabel}</div>
          <h2 className="section-title">{t.locTitle}</h2>
          <p className="section-subtitle">{t.locSubtitle}</p>
        </div>
        <div className="location-grid reveal-item" style={visible ? { opacity: 1, transform: 'translateY(0)', transitionDelay: '80ms' } : { transitionDelay: '80ms' }}>
          <div className="location-map-wrapper">
            <iframe src={MAPS_EMBED} title="Super Muffler Inc. location map" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="location-map" aria-label="Map showing Super Muffler Inc." />
          </div>
          <div className="location-info" data-testid="location-hours">
            <div className="walk-ins-banner">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
              {t.locWalkIns}
            </div>
            <div className="location-hours">
              <div style={{ fontFamily: 'Archivo, sans-serif', fontWeight: 800, color: 'var(--sm-blue)', marginBottom: '0.75rem', fontSize: '15px' }}>{t.locHours}</div>
              {hours.map((h, i) => (
                <div key={i} className="hours-row">
                  <span className="hours-day">{h.day}</span>
                  <span className={h.closed ? 'hours-closed' : 'hours-time'}>{h.time}</span>
                </div>
              ))}
            </div>
            <div className="location-address">
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', color: 'var(--sm-muted)' }}>
                <MapPinIcon />
                <div><h3>926 W Main St</h3><p>Santa Maria, CA 93458</p></div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--sm-muted)' }}>
                <PhoneIcon />
                <a href={PHONE_HREF} style={{ color: 'var(--sm-blue)', fontWeight: 700, fontSize: '15px', textDecoration: 'none', fontFamily: 'Archivo, sans-serif' }}>(805) 922-9684</a>
              </div>
            </div>
            <a href={MAPS_HREF} target="_blank" rel="noopener noreferrer" className="btn-primary" style={{ alignSelf: 'flex-start' }} data-testid="location-directions-cta">
              <MapPinIcon /> {t.locDirections}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
